import React from "react";

export const CloseIcon = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M19.7732 5.32163C20.0756 5.01929 20.0756 4.5291 19.7732 4.22676C19.4709 3.92441 18.9807 3.92441 18.6783 4.22676L12 10.9051L5.32163 4.22676C5.01929 3.92442 4.5291 3.92442 4.22676 4.22676C3.92441 4.5291 3.92441 5.01929 4.22676 5.32163L10.9051 12L4.22678 18.6784C3.92444 18.9807 3.92444 19.4709 4.22678 19.7732C4.52912 20.0756 5.01931 20.0756 5.32165 19.7732L12 13.0949L18.6783 19.7732C18.9807 20.0756 19.4709 20.0756 19.7732 19.7732C20.0755 19.4709 20.0755 18.9807 19.7732 18.6784L13.0949 12L19.7732 5.32163Z"
        fill="#030C23"
      />
    </svg>
  );
};
